<template>
    <div id="actlie">

        <div class="fflex fflexV fflexbet" style="margin-bottom: 0.2rem">
            <el-button size="mini" class="qianzBtn" round @click="jump('newact')">新建</el-button>

            <div class="cirBox" style="margin:  10px 0">
                <select name="" @change="click_huo" v-model="huod" class="xiala"
                        style="border-radius: 14px;  box-shadow: 0 2px 12px 0 rgba(0,0,0,.2);margin-right: 0.4rem"
                        id="">
                    <option value="">活动分类</option>
                    <option value="1">会员活动</option>
                    <option value="2">潜客活动</option>
                </select>


                <el-input
                        class="yuaninp"
                        style="width: 160px;margin-right: 20px"
                        size="mini"
                        v-model="activity_s"
                        placeholder="活动标题"
                >

                    <i class="el-icon-search el-input__icon"
                       slot="suffix"
                       v-on:click="searchname">
                    </i>
                </el-input>
            </div>
        </div>

        <div class="tableBox">
            <table class="table table-bordered">
                <thead>
                <tr>
                    <th>序号</th>
                    <th>名称</th>
                    <th>活动时间</th>
                    <th>分类</th>
                    <th>状态</th>
                    <th>活动二维码</th>
                    <th>活动链接</th>
                    <th>操作</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in activity_list">
                    <td>{{index+1}}</td>
                    <!-- <td @click="jump('actdetail',1)">{{item.group_name}}</td> -->
                    <td>{{item.group_name}}</td>
                    <td>{{item.start_time}}至{{item.end_time}}</td>
                    <td>
                        <span v-if="item.type==1">会员活动</span>
                        <span v-if="item.type==2">潜客活动</span>
                    </td>
                    <td>{{item.g_status}}</td>
                    <td @click="click_code(item.code_img)" style="color: #0086B3;">查看二维码</td>
                    <td>
                        <input type="text" :value="item.url" style="width:1px;height:0;border:0;">
                        <button class="td_btn" @click="copy_url(index,$event.target)">复制</button>
                    </td>
                    <td>
                        <el-button type="danger" size="mini" @click="click_delete(item.id)">删除</el-button>
                    </td>
                </tr>


                </tbody>
            </table>
            <p style="float:left;">共有{{zong}}条记录 当前{{page}}页/共{{page_total}}页</p>

            <div class="table-bottom" style="margin-bottom: 0.2rem;float: right">
                <div>
                    <el-pagination
                            @current-change="fanye"
                            :page-size="pageone"
                            :page-count="page_total"
                            :current-page="currentpage"
                            background
                            layout="prev, pager, next"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>

        <el-dialog
                title="查看二维码"
                :visible.sync="dialog_code"
                width="18%"
                center>
            <div style="width: 100%;text-align: center;">
                <img width="200" height="200" :src="code_img"/>
            </div>
        </el-dialog>


        <!--<div><router-link :to="{ name: 't1'}">t1</router-link> <router-link :to="{ name: 't2'}">t2</router-link></div>-->
        <!--<router-view/>-->


    </div>

</template>

<script>
    //    import Router from 'vue-router'
    //    const t1 = {
    //        template: '<div>User</div>'
    //    }
    //    const t2 = {
    //        template: '<div>User</div>'
    //    }
    //    const router = new Router({
    //        routes: [
    //            // 动态路径参数 以冒号开头
    //            { path: '/t1', component: t1 },
    //            { path: '/t2', component: t2 }
    //        ]
    //    })
    //


    export default {
        data() {
            return {
                cook: '',
                activity_list: '',
                currentpage: 1,
                pageone: 5,
                dialog_code: false,//二维码
                code_img: "",
                huod: "",
                activity_s: '',
                page_total: '',
                page: 1,
                zong: '',

            }
        },
        methods: {
            copy_url:function(index,t){
                var inputa =$(t).prev();
                var val = $(t).prev().val();
                inputa.select(); // 选中文本
                document.execCommand("copy"); // 执行浏览器复制命令
                this.$message.success("复制成功");
            },
            index_list: function () {
                var self = this
                $.ajax({
                    url: process.env.apiUrl + "saas/activitycrm/index",
                    type: "post",
                    dataType: 'json',
                    data: {
                        token: self.cook,
                        type: self.huod,
                        group_name: self.activity_s,
                        page: this.page,
                    },
                    success: function (e) {
                        console.log(e)
                        self.activity_list = e.data
                        self.page_total = Number(e.map.pagetotal)
                        self.zong = Number(e.map.count)
                    }
                });
            },
            click_huo: function () {
                this.index_list()
            },
            // 搜索
            searchname: function () {
                this.index_list()

            },
            jump: function (e, id) {
                this.$router.push({
                    name: e,
                    query: {
                        id: id
                    }
                })
            },
            //分页
            fanye: function (i) {
                this.page = i
                this.index_list()

            },
            // 二维码
            click_code: function (img) {
                this.dialog_code = true//二维码
                this.code_img = img
            },
            //删除
            click_delete: function (id) {
                this.$confirm('是否删除此活动?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }).then(() => {
                    var self = this
                    $.ajax({
                        url: process.env.apiUrl + "saas/activitycrm/hd_delete",
                        type: "post",
                        dataType: 'json',
                        data: {
                            token: self.cook,
                            id: id
                        },
                        success: function (e) {
                            console.log(e)
                            if (e.status == 1) {
                                self.index_list()
                                self.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                            }
                        }
                    });


                });
            },

        },
        filters: {},
        watch: {  //watch()监听某个值（双向绑定）的变化，从而达到change事件监听的效果

        },

        mounted: function () {
            var self = this
            self.cook = self.$cookies.get("token")
            self.index_list()

        }


    }
</script>

<style scoped>
    .xiala {
        width: 140px;
        height: 28px;
        line-height: 28px;
        background-color: #fff;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        font-size: 13px;
        outline: 0;
        padding: 0 15px;
        -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
        transition: border-color .2s cubic-bezier(.645, .045, .355, 1);

    }

    #actlie, #actlie * {
        box-sizing: border-box;
    }

    #actlie {
        font-size: 13px;
        padding: 0.2rem;
    }

    .fflex {
        display: flex
    }

    .fflexV {
        align-items: center;
    }

    .fflexC {
        justify-content: center;
    }

    .fflexbet {
        justify-content: space-between;
    }

    .qianzBtn {
        background: #f1f1f1 !important;
        color: #8CBB77 !important;
        height: 28px;
        padding-left: 25px;
        padding-right: 25px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .2);
        /* padding: 12px 23px; */
    }


</style>
<style>
    .yuaninp .el-input__inner {
        border-radius: 14px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .2);
    }

    .yuaninp .el-input__icon {
        font-size: 20px;
        color: #8CBB77;

    }
    .td_btn{
        font-weight: bold;
        width: 70px;
        height: 25px;
        background-color: rgb(232,229,255);
        color: rgb(124,114,193);
        border:0;
        margin: 0 10px;
        border-radius: 20px;
        font-size:12px;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/pages/huodong/actlie.vue